import type { NebulyPageKey, NebulyPageRoute } from '@/domains/pages/types';

import type { StorageKey } from '@/types/storage.types';

export const PAGE_FAVORITE_KEYS_STORAGE_KEY = 'nebuly_page_favorite_keys' satisfies StorageKey;

export const PAGE_KEY_PREFIX = 'page:' as const;
export const REPORT_KEY_PREFIX = 'report:' as const;

/** Longer routes first so pathname prefix matching prefers segment pages over parents. */
export const NEBULY_PAGE_KEYS: NebulyPageKey[] = [
  'ai-spend-team',
  'ai-spend-market',
  'ai-spend-tenure',
  'team',
  'market',
  'tenure',
  'upskilling',
  'ai-proficiency',
  'ai-spend',
  'model-savings',
];

export const NEBULY_PAGE_ROUTES = {
  'ai-proficiency': '/ai-proficiency',
  'ai-proficiency-team': '/ai-proficiency/team',
  'ai-proficiency-market': '/ai-proficiency/market',
  'ai-proficiency-tenure': '/ai-proficiency/tenure',
  team: '/ai-proficiency/team',
  market: '/ai-proficiency/market',
  tenure: '/ai-proficiency/tenure',
  upskilling: '/ai-proficiency/upskilling',
  'ai-spend': '/roi/ai-spend',
  'ai-spend-team': '/roi/ai-spend/team',
  'ai-spend-market': '/roi/ai-spend/market',
  'ai-spend-tenure': '/roi/ai-spend/tenure',
  'model-savings': '/roi/model-savings',
} as const satisfies Record<NebulyPageKey, NebulyPageRoute>;

export function getNebulyPageRoute(pageKey: NebulyPageKey): NebulyPageRoute {
  return NEBULY_PAGE_ROUTES[pageKey];
}

export function isAifiNebulyPagePath(pathname: string): boolean {
  return pathname === '/ai-proficiency' || pathname.startsWith('/ai-proficiency/');
}

export function isRoiNebulyPagePath(pathname: string): boolean {
  return pathname.startsWith('/roi/');
}

export function isNebulyPagePath(pathname: string): boolean {
  return isAifiNebulyPagePath(pathname) || isRoiNebulyPagePath(pathname);
}
